import React from 'react';
import styled from '@emotion/styled';
import { Divider } from '../divider';
import { INPUT_GROUP_DIVIDER_CLASS_NAME } from './constants';
import { getInputGroupDividerLengthBySize } from './styles';
import { InputGroupDividerVariant, InputGroupSize } from './types';

interface InputGroupDividerProps {
  size: InputGroupSize;
  variant: Exclude<InputGroupDividerVariant, 'none'>;
  color: string;
}

const StyledDivider = styled(Divider)`
  flex: none;
  align-self: center;
`;

export const InputGroupDivider = ({ size, variant, color }: InputGroupDividerProps) => (
  <StyledDivider
    className={INPUT_GROUP_DIVIDER_CLASS_NAME}
    direction='vertical'
    length={variant === 'full' ? '100%' : getInputGroupDividerLengthBySize(size)}
    color={color}
  />
);
